<template>
  <div>
    <el-card class="box-card" v-auth="'/role/pageList'">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="角色名称" prop="name" class="form-bottom">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入角色名称"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              :size="buttonSize"
              type="primary"
              @click="pageList"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              v-auth="'/role/pageListreset'"
              :size="buttonSize"
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            v-auth="'/role/addRole'"
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
          ></el-button>
          <el-button
            v-auth="'/role/deleteRole'"
            :size="buttonSize"
            type="danger"
            @click="batchDeleteRole"
            icon="el-icon-minus"
            >批量删除</el-button
          >
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            v-auth="'/role/importData'"
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            >导入</el-button
          >
          <el-button
            v-auth="'/role/exportExcel'"
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="tableLoading"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- v-auth="'/role/updateRole'" -->
              <span
                @click=";(selection = scope.row.id), (editFormVisible = true)"
                >编辑</span
              >
              <span @click="deleteRole(scope.row)"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入角色名称"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="资源"
          :label-width="formLabelWidth"
          prop="resources"
        >
          <el-tree-select
            v-model="addForm.resources"
            :styles="styles"
            :selectParams="selectParams"
            :treeParams="treeParams"
            @node-click="handleNodeClick"
            ref="treeSelect"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="addForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="addRole"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入角色名称"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="资源"
          :label-width="formLabelWidth"
          prop="resources"
        >
          <el-tree-select
            v-model="editForm.resources"
            :styles="styles"
            :selectParams="selectParams"
            :treeParams="treeParams"
            ref="treeSelect"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="updateRole"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button
          :size="buttonSize"
          size="small"
          type="primary"
          icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: ""
      },
      styles: {
        width: "300px"
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源"
      },
      treeParams: {
        clickParent: true,
        filterable: false,
        "check-strictly": true,
        "default-expand-all": true,
        "expand-on-click-node": false,
        "check-on-click-node": true,
        data: [],
        props: {
          children: "resources",
          label: "name",
          disabled: "disabled",
          value: "id"
        }
      },
      addForm: {
        name: "",
        remark: "",
        resources: []
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 48,
            message: "角色名称长度在1到48个字"
          }
        ],
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "备注长度在1到255个字"
          }
        ]
      },
      editForm: {
        name: "",
        remark: "",
        resources: []
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 48,
            message: "角色名称长度在1到48个字"
          }
        ],
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "备注长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/role/upload`,
      fileList: [],
      loading: false,

      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getRole () {
      this.api.role
        .getRole({ id: this.selection })
        .then(result => {
          this.editForm = result.data;
          result.data.resources.map(
            (e, index) => (this.editForm.resources[index] = e.id)
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.role
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false
        })
        .catch(error => {
          this.tableLoading = false
          console.log(error);
        });
    },
    addRole () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.resources.forEach(
            (e, index) => (this.addForm.resources[index] = { id: e })
          );
          this.api.role
            .addRole(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateRole () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editForm.resources.map(
            (e, index) => (this.editForm.resources[index] = { id: e })
          );
          this.api.role
            .updateRole(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteRole (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.role
            .deleteRole([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteRole () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.role
            .deleteRole(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.role
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.role
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResourceTree () {
      this.api.resource
        .getResourceTree()
        .then(result => {
          this.treeParams.data = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleNodeClick (data, node, vm) { }
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getRole();
      }
    }
  },
  mounted () {
    this.pageList();
    this.getResourceTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/role/index.vue